import { createAction } from 'redux-actions'

const defaultPrefix = 'HELP_CENTER/'
let prefix = defaultPrefix

// DATA
prefix = `${defaultPrefix}DATA/`
export const fetchDemosStart = createAction(`${prefix}FETCH_DEMOS_START`)
export const fetchDemosSuccess = createAction(`${prefix}FETCH_DEMOS_SUCCESS`)
export const fetchDemosError = createAction(`${prefix}FETCH_DEMOS_ERROR`)
